/* global anime */
document.addEventListener("DOMContentLoaded", function() {

  var bgHomeSliders = document.querySelectorAll('.bg-home-slider');
    if(bgHomeSliders[0]) {
    var currentSlideID = 0;

    let slider = bgHomeSliders[0];
    let arrowLeft = slider.querySelector('.bg-slider__arrow--left');
    let arrowRight = slider.querySelector('.bg-slider__arrow--right');

    let wipe = anime.timeline({
      duration: 500,
    });

    wipe.add({
      autoplay: false,
      targets: slider.querySelectorAll('.wp-slider__background-cover, .wp-slider__button-cover'),
      delay: anime.stagger(10, {start: 0}),
      easing: 'easeOutQuad',
      width: ['0%', '100%'],
    })

    wipe.add({
      autoplay: false,
      targets: slider.querySelectorAll('.wp-block-button__link'),
      delay: anime.stagger(10, {start: 0}),
      easing: 'easeOutQuad',
      width: ['100%', '0%'],
      complete: function(anim) {
        let covers = slider.querySelectorAll('.wp-slider__background-cover, .wp-slider__button-cover');

        for (let i = 0; i < covers.length; i++) {
          covers[i].style.left = 'auto';
          covers[i].style.right = '0';
        }

        let currentSlide = slider.querySelector('.bg-slider__slide--active');
        let currentBullet = slider.querySelector('.glide__bullet--active');
        
        currentSlide.classList.remove('bg-slider__slide--active');
        currentBullet.classList.remove('glide__bullet--active');      
      
        let newSlideClass = '.bg-slider__slide[data-slideid="' + currentSlideID + '"]';
        let newBulletClass = '.glide__bullet[data-slideid="' + currentSlideID + '"]';
      
        let newSlide = slider.querySelector(newSlideClass);
        let newBullet = slider.querySelector(newBulletClass);

        newSlide.classList.add('bg-slider__slide--active');
        newBullet.classList.add('glide__bullet--active');
        
        reveal.play();
      }
    });

    let reveal = anime.timeline({
      duration: 500,
    });

    reveal.add({
      autoplay: false,
      targets: slider.querySelectorAll('.wp-slider__background-cover, .wp-slider__button-cover'),
      delay: anime.stagger(10, {start: 0}),
      easing: 'easeInQuad',
      width: ['100%', '0%'],
    });

    reveal.add({
      autoplay: false,
      targets: slider.querySelectorAll('.wp-block-button__link'),
      delay: anime.stagger(10, {start: 0}),
      easing: 'easeInQuad',
      width: ['0', '100%'],
      complete: function(anim) {

        let covers = slider.querySelectorAll('.wp-slider__background-cover, .wp-slider__button-cover');

        for (let i = 0; i < covers.length; i++) {
          covers[i].style.left = '0';
          covers[i].style.right = 'auto';
        }
      }
    })

    function homeSliderTimer () {
      currentSlideID++;
      if(currentSlideID > 6) {
        currentSlideID = 0;
      }
      wipe.play();
    }

    let homeSliderTimerInterval = setInterval(homeSliderTimer, 5000);
    let homeBullets = slider.querySelectorAll('.glide__bullet');

    for( let itwo = 0; itwo < homeBullets.length; itwo++ ) {
      homeBullets[itwo].addEventListener('click', function() {
        currentSlideID = this.getAttribute('data-slideid');
        clearInterval(homeSliderTimerInterval);
        homeSliderTimerInterval = setInterval(homeSliderTimer, 7000);
        wipe.play();
      })
    }

    arrowLeft.addEventListener('click', function(event) {
      currentSlideID--;
      if(currentSlideID < 0) {
        currentSlideID = 6;
      }
      clearInterval(homeSliderTimerInterval);
      homeSliderTimerInterval = setInterval(homeSliderTimer, 7000);
      wipe.play();
    });

    arrowRight.addEventListener('click', function(event) {
      currentSlideID++;
      if(currentSlideID > 6) {
        currentSlideID = 0;
      }
      clearInterval(homeSliderTimerInterval);
      homeSliderTimerInterval = setInterval(homeSliderTimer, 7000);
      wipe.play();
    });
  }
});